import { useSelector } from "react-redux";
import { ENTITY } from "../../redux/slices/timeline";



export function getEntityData() {
  const { currentEntity } = useSelector((state: any) => state.timeline);
  const roadmapState = useSelector((state: any) => state.roadmap);

  return currentEntity == ENTITY.PROJECT
    ? (roadmapState.projectApiPayload as ProjectEntityType)
    : (roadmapState.singleRoadmapRes as RoadmapEntityType);
}


export type RoadmapEntityType = {
  id: string;
  name: string;
  type: string;
  description: string;

  project_ids: string[];

  projects: {
    project_id: string;
    project_name: string;
    stage: string;
    status: string;
    project_description: string;
    start_date: string;
    end_date: string;
    progress: number;

    members: unknown[];

    project_costs: {
      total_cost: number;
      total_billing: number;
    };

    sim_data: {
      project_costs: {
        total_cost: number;
        total_billing: number;
      };
      start_date: string;
      end_date: string;
      status: string;
      progress: number;
    };

    dependencies: unknown[];
    integration_data: unknown | null;
    source: string;
    entity_type: string;
    is_sim_pending: boolean;
  }[];

  created_at: string;
  created_by: string;
  sim_log: string;

  milestones: unknown[];
  dependencies: unknown[];
  integration_data: unknown | null;

  stats: {
    total: number;
    on_track: number;
    not_started: number;
    completed: number;
    closed: number;
    at_risk: number;
  };

  status: string;
  progress: number;
  members: unknown[];

  start_date: string;
  end_date: string;

  entity_type: string;

  child_entity_types: {
    [key: string]: number;
  };

  sim_data: {
    start_date: string;
    end_date: string;
    progress: number;
    status: string;
    stats: {
      total: number;
      on_track: number;
      not_started: number;
      completed: number;
      closed: number;
      at_risk: number;
    };
    project_costs: {
      total_cost: number;
      total_billing: number;
    };
  };

  project_costs: {
    total_cost: number;
    total_billing: number;
  };

  priority: string;
  stage: string;
  is_sim_pending: boolean;
};


export type ProjectEntityType = {
  id: string;
  name: string;
  type: string;

  tasks: unknown[];

  sim_data: {
    tasks: unknown[];
    status: string;
    progress: number;

    skills_required: unknown[];

    duration: number;
    duration_with_delay: number;
    duration_with_working_days: number;

    critical_path: unknown[];

    start_date: string;
    end_date: string;

    project_costs: {
      total_cost: number;
      total_billing: number;
    };

    skill_capacity_percent: Record<string, number>;
    skill_members: Record<string, unknown>;

    stats: {
      total: number;
      completed: number;
      delayed: number;
      on_track: number;
      unallocated: number;
      not_started: number;
      closed: number;
      blocked: number;
    };

    share_link: boolean;
  };

  members: unknown[];

  progress: number;

  skills_required: unknown[];

  duration: number;
  duration_with_delay: number;
  duration_with_working_days: number;

  critical_path: unknown[];

  start_date: string;
  end_date: string;

  project_costs: {
    total_cost: number;
    total_billing: number;
  };

  durations: unknown[];

  is_sim_pending: boolean;

  skill_capacity_percent: Record<string, number>;
  skill_members: Record<string, unknown>;

  share_link: boolean;
  created_by_template: boolean;

  integration_data: unknown | null;

  status: string;

  stats: {
    total: number;
    completed: number;
    delayed: number;
    on_track: number;
    unallocated: number;
    not_started: number;
    closed: number;
    blocked: number;
  };

  entity_type: string;

  child_entity_types: Record<string, number>;

  stage: string;

  resources_used_in_tasks: Record<string, unknown>;

  parent_info: {
    id: string;
    type: string;
    entity_type: string;
  };
};


